import { reactive } from 'vue'
import { IContainerMenuitem } from '../interface'

// 注册左侧带单组件的方法
const getLayoutMenu = function () {
  let compsList: IContainerMenuitem[] = reactive([])
  let compsMap: { [key: string]: IContainerMenuitem } = reactive({})
  return {
    compsList,
    compsMap,
    register(compName: string, menuItem: IContainerMenuitem) {
      // 添加额外的公共属性
      const { dropedInfo } = menuItem
      const { attrsConfig = []} = dropedInfo
      attrsConfig.unshift('style')
      attrsConfig.push('vif', 'ref')
      dropedInfo.attrsConfig = Array.from(new Set(attrsConfig))
      if (!dropedInfo.style) dropedInfo.style = ''
      if (!dropedInfo.vif) dropedInfo.vif = ''
      if (!dropedInfo.ref) dropedInfo.ref = ''
      // 正式添加到数组
      compsList.push(menuItem)
      compsMap[compName] = menuItem
    }
  }
}

// 左侧布局实例菜单
export const menuLayout = getLayoutMenu()

// 本地定义基本布局
export const basicLayout = {
  tag: 'div',
  isroot: true,
  iscontainer: true,
  isfixed: true,
  styleConfig: { width: '100%', height: 'auto', position: 'relative', background: '#fff'},
  attrsConfig: ['style'],
  style: 'min-height: 700px; max-width:1200px; min-width:320px;'
}


// 开始注册布局
menuLayout.register('SelfDefine', {
  compLabel: '自定义标签/组件',
  dropedInfo: {
    tag: 'div',
    iscontainer: true,
    isfixed: false,
    selfDefineTag: true, // 自定义标签
    styleConfig: { position: 'absolute', 'z-index': 5, color: '', background: '#eee', 'font-size': 14, width: 200, height: 100 },
    attrsConfig: ['text'],
    text: '这是一个自定义组件或者标签',
    eventConfig: [],
    selfConfig: []
  }
})
menuLayout.register('RelativeDiv', {
  compLabel: 'div　relative标签',
  dropedInfo: {
    tag: 'div',
    iscontainer: true,
    isfixed: true,
    styleConfig: { position: 'relative', 'z-index': 5, color: '', background: '#f9f9f9', 'font-size': 14, width: '100%', height: 300 },
    attrsConfig: ['text', 'className', 'vfor'],
    text: '这是一个相对定位的div标签',
    eventConfig: ['onClick']
  }
})
menuLayout.register('AbsoluteDiv', {
  compLabel: 'div　absolute标签',
  dropedInfo: {
    tag: 'div',
    iscontainer: true,
    isfixed: false,
    styleConfig: { position: 'absolute', 'z-index': 10, color: '', background: '#f4f4f4', 'font-size': 14, width: 200, height: 200 },
    attrsConfig: ['text', 'className', 'vfor'],
    text: '这是一个绝对定位的div标签',
    eventConfig: ['onClick']
  }
})
menuLayout.register('ALink',{
  compLabel: 'a　链接标签',
  dropedInfo: {
    tag: 'a',
    iscontainer: false,
    isfixed: false,
    styleConfig: { position: 'absolute', 'z-index': 100, color: '#333', background: 'transparent', 'font-size': 14, width: 'auto', height: 'auto' },
    attrsConfig: ['text', 'href', 'className'],
    text: '这是一个a标签',
    eventConfig: ['onClick']
  }
})
menuLayout.register('SpanText', {
  compLabel: 'span　文本标签',
  dropedInfo: {
    tag: 'span',
    iscontainer: false,
    isfixed: false,
    styleConfig: { position: 'absolute', 'z-index': 100, color: '#333', background: 'transparent', 'font-size': 14, width: 'auto', height: 'auto' },
    attrsConfig: ['text', 'vfor', 'className'],
    text: '这是一个span标签',
    eventConfig: ['onClick']
  }
})

menuLayout.register('Image', {
  compLabel: 'img　图片标签',
  dropedInfo: {
    tag: 'img',
    iscontainer: false,
    isfixed: false,
    draggable: false,
    styleConfig: { position: 'absolute', 'z-index': 200, width: 100, height: 'auto' },
    attrsConfig: ['src'],
    src: 'https://www.baidu.com/img/flexible/logo/pc/result.png',
    eventConfig: ['onClick']
  }
})

menuLayout.register('KIcon', {
  compLabel: 'KIcon　icon组件',
  dropedInfo: {
    tag: 'KIcon',
    iscontainer: false,
    isfixed: false,
    styleConfig: { position: 'absolute', 'z-index': 200, color: '#333', 'font-size': 14, },
    attrsConfig: ['iconname', 'loading'],
    eventConfig: ['onClick']
  }
})

menuLayout.register('KButton', {
  compLabel: 'KButton　按钮组件',
  dropedInfo: {
    tag: 'KButton',
    iscontainer: true,
    isfixed: false,
    styleConfig: { position: 'absolute', 'z-index': 200, width: 80, height: 'auto'},
    attrsConfig: ['buttonStyle', 'text', 'theme', 'size', 'disabled', 'icon', 'loading', 'round'],
    text: '按钮',
    theme: 'primary',
    eventConfig: ['onClick'],
  }
})

menuLayout.register('KInput', {
  compLabel: 'KInput　输入框',
  dropedInfo: {
    tag: 'KInput',
    iscontainer: true,
    isfixed: false,
    styleConfig: { position: 'absolute', 'z-index': 200, width: 100, height: 'auto' },
    attrsConfig: ['inputStyle', 'vmodel', 'placeholder', 'type', 'theme','size', 'disabled', ],
    vmodel: '{_data.attr}',
    placeholder: '请输入',
    type: 'text',
    theme: 'default',
    eventConfig: ['onChange', 'onBlur','onInput','onFocus','onKeydown','onKeyup'],
  }
})
